import { mapStyles } from "./map-styles";

declare const google: any;

export const getMapOptions = () => ({
    center: new google.maps.LatLng(49.8402622, 15.6578156),
    zoom: 7,
    maxZoom: 18,
    minZoom: 6,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    zoomControl: true,
    panControl: false,
    fullscreenControl: false,
    zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.LEFT_CENTER,
    },
    streetViewControl: false,
    styles: mapStyles,
});
